"use strict";

angular.module('PatientApp').factory('LoadingIndicatorService', function (VuexStore) {
  return {
    loading: function loading() {
      return VuexStore.dispatch('loadLoadingIndicator');
    },
    complete: function complete(key) {
      return VuexStore.dispatch('completeLoadingIndicator', key);
    },
    isVisible: VuexStore.state.AppStore.isLoadingIndicatorVisible
  };
});